import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const TransparentActivityFilter = () => {
	const {
		activityButtonId,
		setActivityButtonId,
		setActivityButtonActive,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	const changeActivityHandler = (event) => {
		setActivityButtonId(event.target.value);
		setActivityButtonActive(true);
	};

	return (
			<div className="c-transparent-filter__dropdown">
				<div className="c-input dropdown ">
				<label className="c-input__label">{dictionaryWords.what}</label>
				<select 
					id="activity_filter"
					className="c-input__field c-toggle-label"
					onChange={changeActivityHandler}
					value={activityButtonId}
				>
					<option value="all">{dictionaryWords.allTypes}</option>
					<option value="beurs">{dictionaryWords.fair}</option>
					<option value="sportkamp">{dictionaryWords.sportCamp}</option>
					<option value="sportactiviteit">
						{dictionaryWords.activity}
					</option>
					<option value="fiets_wandel">
						{dictionaryWords.cyclingWalking}
					</option>
					<option value="lezing_congres">
						{dictionaryWords.seminarConference}
					</option>
					<option value="lessen_cursus_workshop">
						{dictionaryWords.coursesWorkshops}
					</option>
				</select>
			</div>
			</div>
	);
};

export default TransparentActivityFilter;
